import type { ProductImageEntry } from "./types";

export const ASK_CAIRE_DETAIL_CATALOGUE: readonly ProductImageEntry[] = [
  {
    id: "ai.ask-caire-workspace-prompts",
    module: "Fråga CAIRE",
    area: "ai",
    opens: "Fråga CAIRE → Arbetskontext → Optimera en lösning",
    setup: [
      "Öppna Fråga CAIRE-arbetsytan för Nacka CAIRE (Demo)",
      "Rulla konversationen till det synliga startkortet för att optimera en lösning",
      "Granska schemavalet och Fortsätt-knappen utan att välja schema eller skicka formuläret",
    ],
    scenario: "S6",
    visual: { variant: 5, focus: "quick-prompts" },
    text: {
      sv: {
        alt: "Startkort för att optimera en lösning med schemaval i Fråga CAIRE",
        shows:
          "Granska det synliga startkortet och välj vilket schema en ny lösning ska utgå från.",
        proves:
          "Kortet kräver ett schema innan planeraren kan fortsätta för att förbereda en lösning. Bilden visar formulärets startläge; inget schema väljs och ingen lösning förbereds.",
      },
      en: {
        alt: "Ask CAIRE start card for optimising a solution with schedule selection",
        shows:
          "Review the visible start card and choose which schedule a new solution should use.",
        proves:
          "The card requires a schedule before the planner can continue to prepare a solution. The image shows the form at its starting state; no schedule is selected and no solution is prepared.",
      },
    },
    use: ["pages/Features/AiChat.tsx", "pages/Plattform.tsx"],
  },
  {
    id: "ai.ask-caire-foundation-context",
    module: "Planeringsgrund",
    area: "ai",
    opens: "Fråga CAIRE → Arbetskontext",
    setup: [
      "Öppna Fråga CAIRE-arbetsytan med den valda enheten",
      "Granska aktuell grundstatus och nästa rekommenderade steg",
    ],
    scenario: "S6",
    visual: { variant: 5, focus: "setup" },
    text: {
      sv: {
        alt: "Aktuell planeringsgrund och enhetskontext i Fråga CAIRE",
        shows:
          "Se vilken enhet konversationen gäller och hur planeringsgrunden visas just nu.",
        proves:
          "Arbetskontexten och grundstatusen läses från den valda organisationens data. Vyn visar aktuell beredskap utan att ändra inställningar eller grunddata.",
      },
      en: {
        alt: "Current planning foundation and service-area context in Ask CAIRE",
        shows:
          "See which service area the conversation uses and how its planning foundation is currently shown.",
        proves:
          "The work context and foundation status are read from the selected organisation's data. The view reports current readiness without changing settings or source data.",
      },
    },
    use: ["pages/Features/Onboarding.tsx", "pages/Plattform.tsx"],
  },
  {
    id: "ai.help-readiness-guide",
    module: "Hjälp och beredskap",
    area: "ai",
    opens: "Planering → Kontextuell hjälp → Optimeringsberedskap",
    setup: [
      "Öppna Hjälp från den valda planeringskontexten",
      "Granska guiden och eventuella aktuella rekommendationer",
    ],
    scenario: "S6",
    visual: { variant: 0 },
    text: {
      sv: {
        alt: "Kontextuell hjälp om optimeringsberedskap",
        shows:
          "Läs hjälp och nästa steg från planeringsvyn med den valda enheten som kontext.",
        proves:
          "Hjälppanelen visar den valda guiden och de rekommendationer som finns tillgängliga för den aktuella kontexten. Att öppna guiden skickar inget meddelande.",
      },
      en: {
        alt: "Contextual help about optimisation readiness",
        shows:
          "Read guidance and next steps from the planning view, scoped to the selected service area.",
        proves:
          "The help panel shows the selected guide and any recommendations available for the current context. Opening the guide sends no message.",
      },
    },
    use: ["pages/Features/Onboarding.tsx", "pages/Plattform.tsx"],
  },
  {
    id: "ai.ask-caire-evidence-detail",
    module: "Svar och underlag",
    area: "ai",
    opens: "Planering → Fråga CAIRE → Svar och underlag",
    setup: [
      "Öppna Fråga CAIRE på den sparade lösningen",
      "Ställ en läsande diagnostikfråga och granska svarets faktiska underlag",
    ],
    scenario: "S6",
    visual: { variant: 5, focus: "evidence" },
    text: {
      sv: {
        alt: "Detalj av Fråga CAIREs svar med synligt källunderlag",
        shows:
          "Granska underlaget som visas tillsammans med ett faktiskt svar om den sparade lösningens diagnostik.",
        proves:
          "Svaret begär diagnostik från den valda lösningen och panelen visar det underlag som tjänsten faktiskt returnerar. Bilden visar inte ett påhittat exempel eller ett genomfört planeringsingrepp.",
      },
      en: {
        alt: "Ask CAIRE answer detail with its visible evidence",
        shows:
          "Review the evidence shown with an actual answer about the saved solution's diagnostics.",
        proves:
          "The question reads diagnostics from the selected solution, and the panel shows the evidence the service actually returns. This is not a fabricated example or a completed planning change.",
      },
    },
    use: ["pages/Features/AiChat.tsx", "pages/Features/Analytics.tsx"],
  },
];
